import React from 'react';
import Notes from './Notes';

const NotesTab = (props) => {
  const { metro, phaseId, projectId } = props;
  return (
    <React.Fragment>
      <Notes projectId={projectId} phaseId={phaseId} metro={metro} />
    </React.Fragment>
  );
};

export default NotesTab;
